import { OpenInNew } from "@mui/icons-material";
import { Button, Grid, Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router";

const LandingCta = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        padding: { xs: 2, md: 8 },
        backgroundColor: "#004268", // todo use theme color
      }}
    >
      <Grid
        container
        sx={{
          padding: 4,
          maxWidth: 800,
        }}
        spacing={8}
      >
        <Grid size={{ xs: 12, md: 5 }}>
          <Stack spacing={2} direction={"column"}>
            <Typography
              variant={"h5"}
              color={"primary.contrastText"}
              textAlign={"center"}
            >
              Get a free emissions reduction report in as little as 10 minutes
            </Typography>
            <Button
              variant={"contained"}
              size={"large"}
              color={"secondary"}
              component={Link}
              to={"/target"}
            >
              Get Started
            </Button>
            <Button
              variant={"outlined"}
              color={"secondary"}
              component={Link}
              to={"/learn-more"}
            >
              Learn more
            </Button>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Stack
            spacing={2}
            sx={{
              border: "1px solid green",
              borderColor: "secondary.main",
              borderRadius: 4,
              paddingTop: 2,
              paddingBottom: 2,
              paddingLeft: 4,
              paddingRight: 4,
            }}
          >
            <Typography variant={"h6"} color={"white"}>
              Explore more options
            </Typography>
            <Typography variant={"body2"} color={"white"}>
              See how Cascade Energy can help you turn the insights in your
              emissions reduction report into action. Visit our decarbonization
              solutions page for details.
            </Typography>
            <Button
              variant={"outlined"}
              color={"secondary"}
              component={Link}
              to={"https://cascadeenergy.com/decarbonization/"}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNew />}
            >
              Decarbonization
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
export default LandingCta;
